import { useEffect, useState } from 'react';

const getTimeLeft = (endDate) => {
  const total = new Date(endDate) - Date.now();
  if (total <= 0) return null;
  return {
    days: Math.floor(total / (1000 * 60 * 60 * 24)),
    hours: Math.floor((total / (1000 * 60 * 60)) % 24),
    minutes: Math.floor((total / (1000 * 60)) % 60),
    seconds: Math.floor((total / 1000) % 60),
  };
};

const PresaleCountdown = ({ endDate, onComplete }) => {
  const [timeLeft, setTimeLeft] = useState(() => getTimeLeft(endDate));

  useEffect(() => {
    const timer = setInterval(() => {
      const remaining = getTimeLeft(endDate);
      setTimeLeft(remaining);
      if (!remaining) {
        clearInterval(timer);
        if (onComplete) onComplete();
      }
    }, 1000);
    return () => clearInterval(timer);
  }, [endDate, onComplete]);

  if (!timeLeft) return null;

  const units = [
    { label: 'Days', value: timeLeft.days },
    { label: 'Hours', value: timeLeft.hours },
    { label: 'Min', value: timeLeft.minutes },
    { label: 'Sec', value: timeLeft.seconds },
  ];

  return (
    <div className="presale-countdown">
      {units.map(({ label, value }) => (
        <div className="presale-countdown-unit" key={label}>
          <span className="presale-countdown-value">
            {String(value).padStart(2, '0')}
          </span>
          <span className="presale-countdown-label">{label}</span>
        </div>
      ))}
    </div>
  );
};

export default PresaleCountdown;
